import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { OneTimePaymentRequest, OneTimePaymentResponse } from "../../../../models";
import { PrintPaymentReceiptComponent } from "./print-payment-receipt/print-payment-receipt.component";


@Component({
    templateUrl: "./payment-submitted-dialog.component.html",
    styleUrls: ["./payment-submitted-dialog.component.scss"],
})
export class PaymentSubmittedDialogComponent implements OnInit
{

    public referenceNumbers: string[];

    constructor(
        public dialogRef: MatDialogRef<PaymentSubmittedDialogComponent>,
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: { otpResponse: OneTimePaymentResponse[], paymentInfo: OneTimePaymentRequest },
    ) { }

    ngOnInit(): void
    {
        this.referenceNumbers = this.checkDuplicateRefNumbers();
    }

    public checkDuplicateRefNumbers(): string[]
    {
        const myArray: string[] = [];

        // create array of all ref numbers
        for (const item of this.data.otpResponse)
        {
            myArray.push(item.RefNumber);
        }
        // filter out duplicate ref numbers, only display non-duplicates in confirmation dialog.
        return Array.from(new Set(myArray));
    }

    public handleDoneClick(): void
    {
        this.dialogRef.close();
    }

    public printReceipt()
    {

        //this.dialogRef.close();

        const dialogRef = this.dialog.open(PrintPaymentReceiptComponent, {
            minWidth: 400,
            maxWidth: "600px",
            minHeight: "600px",
            disableClose: true,
        });
        const instance = dialogRef.componentInstance;
        instance.otpResponse = this.data.otpResponse;
        instance.paymentInfo = this.data.paymentInfo;

        dialogRef.afterClosed().subscribe(_ =>
        {
            this.dialog.closeAll();
        });

    }
}

